import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import backend from "../../../../api";
import { Button, CircularProgress, Typography, Box } from "@mui/material";

const EmoneyDetails = ({ accountDetails }) => {
  const { user } = useSelector((state) => state.auth);
  const [emailSent, setEmailSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleVerification = async () => {
    setIsLoading(true);
    try {
      const payload = {
        userId: user?.user?._id,
        type: "e-money",
        accountId: accountDetails?.accountId,
        redirectUrl: `/view-account/e-money/${accountDetails?.accountId}/${accountDetails?._id}`,
      };

      const response = await backend.post(
        "/accounts/resend-verify-email",
        payload
      );
      toast.success(response?.data?.message || "Verification email sent!");
      setEmailSent(true);
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to send email. Please try again!"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-body">
        <Typography variant="h6" sx={{ marginBottom: "8px" }}>
          E-money Details
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: "4px" }}>
          <strong>Account ID:</strong> {accountDetails?.accountId}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: "16px" }}>
          <strong>Status:</strong>{" "}
          {accountDetails?.isVerified ? (
            <span style={{ color: "green" }}>Verified</span>
          ) : emailSent ? (
            <span style={{ color: "blue" }}>
              Verification email sent! Please check your email.
            </span>
          ) : (
            <span style={{ color: "red" }}>Not Verified</span>
          )}
        </Typography>

        {!accountDetails?.isVerified && !emailSent && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleVerification}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : null}
            size="small"
            className="mt-3"
          >
            {isLoading ? "Sending..." : "Send Verification Email"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmoneyDetails;
